var exports = {
  "kL": "ChannelChatLayout.module__container___SWZ6NE",
  "Yx": "ChannelChatLayout.module__messagesArea___SWZ6NE",
  "gA": "ChannelChatLayout.module__textareaArea___SWZ6NE",
};

module.exports = exports;
